import {
  createChartFrame,
  resolveTitle,
  resolvePalette,
  clearSvg,
  getLayout,
  createSvgEl,
  scaleLinear,
  toNumber
} from './chart-utils.js';

const DEFAULT_VALUES = [3, 5, 4, 6, 5, 7, 6, 8];

export function render({ node }) {
  const { root, svg, legend, titleEl } = createChartFrame(node, 'Sparkline');

  const update = (next) => {
    titleEl.textContent = resolveTitle(next, 'Sparkline');
    legend.style.display = 'none';
    legend.innerHTML = '';

    clearSvg(svg);
    const layout = getLayout({ pad: 12, padTop: 12, padBottom: 12, padLeft: 12, padRight: 12 });

    const values = resolveValues(next);
    const palette = resolvePalette(next);
    const color = next?.props?.color || next?.data?.color || palette[0];

    const bounds = computeBounds(values, next);
    const points = values.map((val, idx) => ({ x: idx, y: toNumber(val, 0) }));
    const d = points
      .map((pt, idx) => {
        const x = scaleLinear(pt.x, bounds.xMin, bounds.xMax, layout.inner.x, layout.inner.x + layout.inner.w);
        const y = scaleLinear(pt.y, bounds.yMin, bounds.yMax, layout.inner.y + layout.inner.h, layout.inner.y);
        return `${idx === 0 ? 'M' : 'L'} ${x} ${y}`;
      })
      .join(' ');

    const path = createSvgEl('path', {
      d,
      fill: 'none',
      stroke: color,
      'stroke-width': 2
    });
    path.classList.add('ew-chart-line');
    svg.appendChild(path);
  };

  update(node);
  return { el: root, update };
}

function resolveValues(node) {
  const raw = node?.data?.values ?? node?.props?.values;
  if (Array.isArray(raw)) return raw;
  return DEFAULT_VALUES;
}

function computeBounds(values, node) {
  let xMin = 0;
  let xMax = Math.max(1, values.length - 1);
  let yMin = Math.min(...values.map((v) => toNumber(v, 0)));
  let yMax = Math.max(...values.map((v) => toNumber(v, 0)));
  if (!Number.isFinite(yMin)) yMin = 0;
  if (!Number.isFinite(yMax)) yMax = yMin + 1;
  if (yMin === yMax) yMax = yMin + 1;

  const minYOverride = toNumber(node?.props?.minY ?? node?.data?.minY, NaN);
  const maxYOverride = toNumber(node?.props?.maxY ?? node?.data?.maxY, NaN);

  return {
    xMin,
    xMax,
    yMin: Number.isFinite(minYOverride) ? minYOverride : yMin,
    yMax: Number.isFinite(maxYOverride) ? maxYOverride : yMax
  };
}
